import { Dispatch } from 'redux';
import Echo from 'laravel-echo';

import Teacher from '../../types/Teacher';

import {
  addTeacher,
  updateTeacher,
  deleteTeacher,
} from '../../redux/reducers/TeachersReducer';

export default function subscribeToTeachersChannel(
  echo: Echo,
  dispatch: Dispatch,
) {
  echo
    .private('teachers')
    .listen('Teachers\\TeacherCreated', ({ teacher }: { teacher: Teacher }) => {
      dispatch(addTeacher(teacher));
    });

  echo
    .private('teachers')
    .listen('Teachers\\TeacherUpdated', ({ teacher }: { teacher: Teacher }) => {
      dispatch(updateTeacher(teacher));
    });

  echo
    .private('teachers')
    .listen('Teachers\\TeacherDeleted', ({ id }: { id: number }) => {
      dispatch(deleteTeacher(id));
    });
}
